import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { ChildDashboard, LinkedChild, Restrictions, RestrictionsPayload } from '../types'

export const parentalApi = {
  fetchChildren: () => apiClient.get<ApiResponse<LinkedChild[]>>('/parental/children'),

  fetchChildDashboard: (childId: string) =>
    apiClient.get<ApiResponse<ChildDashboard>>(`/parental/children/${childId}/dashboard`),

  fetchRestrictions: (childId: string) =>
    apiClient.get<ApiResponse<Restrictions>>(`/parental/children/${childId}/restrictions`),

  updateRestrictions: (childId: string, payload: RestrictionsPayload) =>
    apiClient.put<ApiResponse<Restrictions>>(`/parental/children/${childId}/restrictions`, payload),
}
